import classNames from 'classnames';
import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'store';

import Button from 'components/Button';

import { selectRooms } from 'store/slices/searchBox';

const OccupancyPopup = ({
    close,
    className,
    changeRoomCount,
    changeAdultsCount,
    changeChildrenCount,
    changeChildAge,
}) => {
    const dispatch = useDispatch();
    const rooms = useSelector(selectRooms);

    const options = (max, start = 0) => {
        const o = [];

        for (let i = start; i <= max; i++) {
            o.push(
                <option value={i} key={i}>
                    {i}
                </option>,
            );
        }

        return o;
    };

    return (
        <div className={className}>
            <div className="occupancy-card">
                {rooms.map((item, key) => (
                    <Fragment key={`room_${key}`}>
                        <div className="row">
                            <div
                                className={classNames(
                                    'form-group room-number',
                                    { 'first-item': key === 0 },
                                )}
                            >
                                <label className="pull-right">
                                    Room {key + 1}:
                                </label>
                            </div>
                            <div className="form-group">
                                <label
                                    // eslint-disable-next-line object-curly-newline
                                    className={classNames({
                                        invisible: key !== 0,
                                        // eslint-disable-next-line object-curly-newline
                                    })}
                                >
                                    Adults
                                </label>
                                <select
                                    className="form-control adults"
                                    name={`occupancy[${key}][adults]`}
                                    value={rooms[key].adults.length}
                                    onChange={(e) =>
                                        dispatch(
                                            changeAdultsCount({
                                                value: e.target.value,
                                                key,
                                            }),
                                        )
                                    }
                                >
                                    {options(6, 1)}
                                </select>
                            </div>
                            <div className="form-group">
                                <label
                                    // eslint-disable-next-line object-curly-newline
                                    className={classNames({
                                        invisible: key !== 0,
                                        // eslint-disable-next-line object-curly-newline
                                    })}
                                >
                                    Children (0-17)
                                </label>
                                <select
                                    className="form-control children"
                                    name={`occupancy[${key}][children]`}
                                    value={rooms[key].children.length}
                                    onChange={(e) =>
                                        dispatch(
                                            changeChildrenCount({
                                                value: e.target.value,
                                                key,
                                            }),
                                        )
                                    }
                                >
                                    {options(4)}
                                </select>
                            </div>
                        </div>
                        {rooms[key].children.length > 0 ? (
                            // eslint-disable-next-line react/jsx-indent
                            <div className="row">
                                <div className="ages-container">
                                    {key === 0 &&
                                        rooms.reduce(
                                            (running, i) =>
                                                running + i.children.length,
                                            0,
                                        ) > 0 && (
                                            <label>
                                                Child ages on return date
                                            </label>
                                        )}
                                    <div className="ages">
                                        {rooms[key].children.length > 0 && (
                                            <>
                                                {rooms[key].children.map(
                                                    (child, childkey) => (
                                                        <select
                                                            key={`child_${childkey}`}
                                                            className="form-control age"
                                                            name={`occupancy[${key}][ages][${childkey}]`}
                                                            value={
                                                                child.age ?? 0
                                                            }
                                                            onChange={(e) =>
                                                                dispatch(
                                                                    changeChildAge(
                                                                        {
                                                                            value:
                                                                                e
                                                                                    .target
                                                                                    .value,
                                                                            key,
                                                                            childkey,
                                                                        },
                                                                    ),
                                                                )
                                                            }
                                                        >
                                                            {options(17)}
                                                        </select>
                                                    ),
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </Fragment>
                ))}
                <div className="row btn-row">
                    <div>
                        <select
                            className="form-control rooms"
                            name="rooms"
                            value={rooms.length}
                            onChange={(e) =>
                                dispatch(changeRoomCount(e.target.value))
                            }
                        >
                            <option value="1">1 Room</option>
                            <option value="2">2 Rooms</option>
                            <option value="3">3 Rooms</option>
                        </select>
                    </div>
                    <Button action={close} btnStyle="primary">
                        Done
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default OccupancyPopup;
